// extracted by mini-css-extract-plugin
export default {"platformGlance":"BestFor_platformGlance__z8sZ3","content":"BestFor_content__bUgPT","image":"BestFor_image__wppYl","circle":"BestFor_circle__m9bw3"};